import React, { useEffect, useMemo, useState } from 'react';
import { askOnComplete, metricCaptureType } from '@battleops/shared';
import { useTasks } from '@battleops/client/src/context/TaskContext';
import { useMetrics } from '@battleops/client/src/data/useMetrics';
import { Capture } from './RoutineMode';
import s from './Metrics.module.css';

// A task was done whose template asks for a number (paint used…) and the quote doesn't answer it: ask now, with the
// routine capture inputs. Skip leaves it on the job's trust meter.
export default function MetricCapture() {
  const { pendingCapture: task, clearCapture } = useTasks();
  const { business, values, capture } = useMetrics();
  const ask = useMemo(() => (task ? askOnComplete(task, business, values) : []), [task, business, values]);
  const [vals, setVals] = useState({});
  useEffect(() => { setVals({}); if (task && !ask.length) clearCapture(); }, [task?.id, ask.length]);
  if (!task || !ask.length) return null;
  const save = () => {
    capture(task, ask.map((d) => ({ metricId: d.id, value: vals[d.id] })).filter((c) => c.value !== undefined && c.value !== null && c.value !== ''));
    clearCapture();
  };
  return (
    <div className={s.scrim} onMouseDown={(e) => { if (e.target === e.currentTarget) clearCapture(); }}>
      <div className={s.sheet} role="dialog" aria-label="Numbers for this task">
        <div className="label">Done · a number for the job</div>
        <h2>{task.title}</h2>
        {ask.map((d) => (
          <div key={d.id} className={s.ask}>
            <div className={s.askName}>{d.name}{d.unit ? ` (${d.unit})` : ''}</div>
            <Capture step={{ title: d.name }} def={{ capture: metricCaptureType(d) }} value={vals[d.id] ?? null} onChange={(v) => setVals((x) => ({ ...x, [d.id]: v }))} accent="var(--c-accent)" />
          </div>
        ))}
        <div className="row" style={{ marginTop: 16 }}>
          <span className="faint" style={{ fontSize: 12 }}>Skipped ones show on the job as missing.</span>
          <span className="spacer" />
          <button className="btn ghost" onClick={clearCapture}>Skip</button>
          <button className="btn primary" onClick={save} disabled={!Object.values(vals).some((v) => v !== null && v !== '' && v !== undefined)}>Save</button>
        </div>
      </div>
    </div>
  );
}
